<template>
	<!--帖子标题 -->
	<div class="tieziInfoBox">
		<!-- 头部 -->
		<div style="overflow-y: auto;height: 100vh;">
			<van-sticky>
				<div class="headerBox">
					<img src="../../assets/img/myicon/indexBgc02.png" alt="" class="backImg">
					<div class="headerQuery">
						<div class="arrImg" @click="backForum">
							<img src="../../assets/img/leftarr_tit.png" alt="">
						</div>
						<p class="header_titile">{{info.category_name}}</p>
						<div class="header_qk">
							<!-- <img src="../../assets/img/ellipsisBlack.png" alt=""> -->
						</div>
					</div>
				</div>
			</van-sticky>
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh" loosing-text="正在获取">
				<div class="tieziTitle" @touchstart="gotouchstart" @touchmove="gotouchmove" @touchend="gotouchend">
					<h4>{{info.title}}</h4>
					<div class="tieziTit_top">
						<div class="tieziListItem_top_left">
							<img :src="$api.$BASE_URL_img + info.user_avatar" alt="" />
						</div>
						<div class="tieziListItem_top_right">
							<p>
								<span v-if="info.anonymous == 0">{{info.nickname}}&nbsp;&nbsp;&nbsp;(楼主)</span>
								<span v-if="info.anonymous == 1">{{info.niming}}&nbsp;&nbsp;&nbsp;(楼主)</span>
							</p>
							<p class="grayColor"><span>{{formatDateTime(info.createtime)}}</span></p>
						</div>
					</div>
					<div class="tieziTit_bottom" v-html="info.content">
						<!-- _book.replace(/\\n/g, '').replace(/\{[\S\s]+\}/) -->
						<div class="tieziTit_bottom_footer">
							<!-- <div class="btn">
						<span class="tieziGl" @click="tzglTost"><i>帖子管理</i><img src="../../assets/img/selectArr.png" alt="" /></span>
						<span class="tieziDel" @click="deleThisTz">删除该帖</span>
					</div> -->
						</div>
					</div>
				</div>
				<div class="navBar">
					<div class="navBarBox" :class="navBarIndex == index ? 'active' : ''" @click="navbarFn(index)" v-for="(item,index) in navbar"
					 :key="index">
						<span>{{item}}</span>
						<p></p>
					</div>
					<!-- <div class="jumpHtgc" v-show="navBarIndex == 1 ? true : false" @click="jumpHtgc">
						<span>前往话题广场</span>
						<img src="../../assets/img/rightarr_pink.png" alt="">
					</div> -->
				</div>
				<!-- 帖子列表 -->
				<div class="tieziListBox" v-show="navBarIndex == 0 ? true : false">
					<div class="tieziListItem" v-for="(item,idx) in reply" :key="idx">
						<div class="tieziListItem_top">
							<div class="tieziListItem_top_left">
								<img :src="$api.$BASE_URL_img + item.user_avatar" alt="" />
							</div>
							<div class="tieziListItem_top_right">
								<p>
									<!-- <span>{{item.nickname}}</span><span v-if="info.user_id == item.user_id">(楼主)</span> -->
									<span v-if="item.anonymous == 1">{{item.niming}}</span>
									<span v-if="item.anonymous == 0">{{item.nickname}}</span>
									<span v-if="info.user_id == item.user_id">(楼主)</span>
									<span class="grayColor">{{idx + 1}}楼</span>
								</p>
								<p class="grayColor">{{formatDateTime(item.createtime)}}</p>
							</div>
						</div>
						<!--  -->
						<div class="tieziListItem_footer" @touchstart="gotouchstart_floor(item.id)" @touchmove="gotouchmove" @touchend="gotouchend">

							<div class="father_reply" v-if="item.father_reply != null">
								<div class="tieziListItem_top_rightFather">
									<span>
										<span>{{item.father_reply.niming}}</span>
										<i class="grayColor">1楼</i>
									</span>
									<span class="grayColor" v-if="item.father_reply.createtime != undefined">{{formatDateTime(item.father_reply.createtime)}}</span>
								</div>
								<div class="txtBox" v-show="txtBoxShow">
									<!-- <p v-if="item.father_reply.c_content.length <=18"><span v-for="(itm,idx) in item.father_reply.c_content">{{itm}}</span></p> -->
									<!-- <p v-html="item.father_reply.c_content"></p> -->
									<!-- <p class="txtBoxOverHidden" @click="toggle" v-if="bookChaptersBody(item.father_reply.c_content).length > 18"><span
										 v-for="(itm,idx) in item.father_reply.c_content" v-if="idx < 38">{{itm}}</span>...</p> -->
										 
									<p class="txtBoxOverHidden" @click="toggle" v-if="item.father_reply.c_content != undefined" v-html="item.father_reply.c_content"><span></span>...</p>
									<div class="dashed"></div>
								</div>
								<div class="txtBox" v-show="!txtBoxShow">
									<!-- <p @click="toggle">{{item.father_reply.c_content}}</p> -->
									<p @click="toggle" v-html="item.father_reply.c_content"></p>
									<div class="dashed"></div>
								</div>
							</div>
							<p class="bor_top" v-html="item.c_content"></p>
							<!-- 楼主可删 -->
							<!-- <img src="../../assets/img/delicon.png" class="del_btn" v-if="is_moderator == 1" @click="delbind(item.id)" /> -->
							<img src="../../assets/img/ltxiaoxi.png" alt="" class="ltxiaoxi" @click="hfFn(item.id,item.niming,item.nickname)">
						</div>
						<!-- <div class="er_reply" v-if="item.children.length">
						<div :class="!item.show_comment ? 'list_item threelist' : 'list_item'" 
							 v-for='(it,index1) in item.children' 
							 :key='it.id' 
							 @touchstart="gotouchstart01(it.id)"
							 @touchmove="gotouchmove" 
							 @touchend="gotouchend"
						>
							<p class="top_text">
								<span class="name">{{it.nickname}}</span>
								<span class="floor">{{index1 + 1}}楼</span>
							</p>
							<p class="time"><span class="er_reply_time">{{formatDateTime(it.createtime)}}</span></p>
							<p class="content">{{it.c_content}}</p>
						</div>
					</div> -->
						<!-- <div v-if="item.children.length > 3"  @click="showComment(idx)" class="more_comment" >
						<span>
							 {{!item.show_comment ? '更多评论' : '收起评论'}}
						</span>
						<img src="../../assets/img/rightArrs.png" alt="">
					</div> -->
					</div>
				</div>
				<!-- 热门话题 -->
				<div class="hotHuati" v-show="navBarIndex == 1 ? true : false">
					<!-- <p class="active">1  #深宫风云之铿锵玫瑰#</p> -->
					<p v-for="(item,idx) in hotTalk" :key="idx">{{item.content}}</p>
				</div>
			</van-pull-refresh>
		</div>

		<!-- 回复 -->
		<div class="huifuInput" v-if="info.is_stick != 1 && navBarIndex != 1">
			<img src="../../assets/img/ltAdd.png" alt="" @click="forumUpimgFn" class="add_imgs">
			<div class="radio_nm">
				<van-checkbox v-model="scRadio" checked-color="#ffdd2b" label-position="left">匿名</van-checkbox>
			</div>
			<!-- class="input_hf"  -->
			<div :class="sendValLength > 4 ? 'input_hf02' : 'input_hf'">
				<!-- <input type="text" :placeholder="'回复：'+nickname" v-if="placeShow == true" @click="editorShow" /> -->
				<!-- {{'回复：'+nickname}} -->
				<i v-if="nickShow" @click.stop="editorShow">{{nickname}}</i>
        <input type="text" v-model="sendValue">
				<editor-bar style="padding-left: 35px" v-model="sendValue" :isClear="isClear" v-if="placeShow" @change="change"></editor-bar>
			</div>
			<span @click="sendFn">发送</span>
		</div>

		<!-- 弹框 -->
		<div class="luntantost" v-show="tostShow">
			<!-- <img src="../../assets/img/cat.png" alt=""> -->
			<div class="luntantostbgc">
				<div @click.stop="forumSetFn(0)" :class="forumSetIdx == 0 ? 'active' : ''" v-if="is_moderator == 1">扎贴</div>
				<div @click.stop="forumSetFn(1)" :class="forumSetIdx == 1 ? 'active' : ''" v-if="is_moderator == 1">置顶</div>
				<div @click.stop="forumSetFn(2)" :class="forumSetIdx == 2 ? 'active' : ''" v-if="is_moderator == 1">加精</div>
				<div @click.stop="forumSetFn(3)" :class="forumSetIdx == 3 ? 'active' : ''" v-if="is_moderator == 1" style="color:#ff4081">删除</div>
				<div @click.stop="forumSetFn(4)" :class="forumSetIdx == 4 ? 'active' : ''">收藏</div>
				<div @click.stop="forumSetFn(5)" :class="forumSetIdx == 5 ? 'active' : ''" v-if="is_moderator != 1">投诉</div>

			</div>
		</div>
		<div class='mask' v-show="tostShow" @click="hideTost"></div>

		<div class="luntantost" v-show="addHfShow">
			<!-- <img src="../../assets/img/cat.png" alt=""> -->
			<div class="luntantostbgc">
				<div v-for="(item,idx) in addHf" @click.stop="addHfFn(idx)" class="active">{{item}}</div>

			</div>
		</div>
		<div class='mask' v-show="addHfShow" @click="hideTost01"></div>


		<!-- 删除楼层 -->
		<div class="luntantost" v-show="addHfShow_floor">
			<!-- <img src="../../assets/img/cat.png" alt=""> -->
			<div class="luntantostbgc">
				<div v-for="(item,idx) in addHf_floor" @click.stop="addHfFn_floor()" class="active">{{item}}</div>
			</div>
		</div>
		<div class='mask' v-show="addHfShow_floor" @click="hideTost_floor"></div>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant';
	import EditorBar from '../../components/wangEnduit.vue'

	export default {
		components: {
			EditorBar
		},
		data() {
			return {
        initialWindowHeight: window.innerHeight, // 初始窗口高度
        keyboardHeight: 0, // 键盘高度
				tostShow: false,
				navBarIndex: 0,
				navbar: ["帖子列表", "热门话题楼"],
				info: {},
				reply: [],
				sendValue: '',
				forum_id: '', //帖子id
				forumShow: true,
				is_moderator: '', //版主 0，否 1 是
				// forumGl:['管理','删除楼层','封账号弹窗'],
				forumGl: ['置顶帖子', '帖子加精', '删除帖子'],
				addHf: ['删除回复'],
				addHf_floor: ['删除楼层'],
				forumSetIdx: null,
				addHfShow: false,
				clearHfId: '',
				hotTalk: [], //话题列表
				nickname: '',
				scRadio: false,
				title: '帖子详情',
				timeOutEvent: 0,
				anonymous_name: ['女娲', '夸父', '宙斯', '雅典娜', '伏羲', '盘古', '嫦娥', '加百列', '红楼梦', '三国演义', '金瓶梅', '水浒传', '西游记', '马良', '白泽',
					'哪吒', '孙悟空', '敖丙', '波塞冬', '太公望', '精卫'
				],
				anonymous_url: ['/uploads/20200331/b6aa12415d510ad363ef17ac77aa0e2c.jpg',
					'/uploads/20200331/62335b1ebab479e0a06b4cbd83b6681a.jpg',
					'/uploads/20200331/027821507b7353583a744b71162e67df.jpg'
				],
				clearHfId_floor: '', //删除楼层的id
				addHfShow_floor: false, //删除楼层弹窗
				txtBoxShow: true,
				placeShow: true, //提示
				placeStr: '',
				isClear: false,
				isLoading: false,
				sendValLength: 0,
				nickShow: true,
			}
		},
		created() {
			this.forum_detail();
			this.hot_talk(); //话题列表
			
		},
		mounted() {
			if (this.sendValLength <= 4) {
				this.placeShow = false;
			}else if (this.sendValLength >= 6) {
				this.placeShow = true;
			}
		},
		methods: {
			onRefresh() {
				setTimeout(() => {
					// Toast('已获取到最新数据');
					this.forum_detail();
					this.isLoading = false;
				}, 1000);
			},
			toggle() {
				this.txtBoxShow = !this.txtBoxShow;
			},
			editorShow() {
				this.sendValLength = 0;
				this.placeShow = false;
			},
			change(val) {
				console.log(val,'val')
				this.nickShow = false;
				this.sendValue = val;
				
				var str = val;
				var pattern = /<[^>]+>/g;
				this.sendValLength = str.match(pattern).length || 0;
				
				var reg = /<\/?.+?\/?>/g;
				var t_content = val.replace(reg, '');
				console.log(t_content,'t_content')
			},
			//字符串解析
			bookChaptersBody(books) {
				if (books) {
					let c = /[\u4E00-\u9FA5\uF900-\uFA2D]/g;
					let _book = JSON.stringify(books).replace(/^"|"$/g, '');
					this.loading = false;
					if (c.test(_book)) {
						_book = '<p>' + _book.replace(/\\n/g, '').replace(/\{[\S\s]+\}/) + '</p>';
						return _book
					}
				}
			},
			gotouchstart() {
				let that = this;
				clearTimeout(that.timeOutEvent); //清除定时器
				that.timeOutEvent = setTimeout(function() {
					//执行长按要执行的内容，
					that.tostShow = true;
					that.addHfShow = false;
				}, 600); //这里设置定时
			},
			gotouchstart01(id) {
				this.clearHfId = id;
				let that = this;
				clearTimeout(that.timeOutEvent); //清除定时器
				that.timeOutEvent = setTimeout(function() {
					//执行长按要执行的内容，
					that.addHfShow = true;
					that.tostShow = false;
				}, 600); //这里设置定时
			},
			gotouchstart_floor(id) {
				this.clearHfId_floor = id;
				let that = this;
				clearTimeout(that.timeOutEvent); //清除定时器
				that.timeOutEvent = setTimeout(function() {
					//执行长按要执行的内容，
					if (that.is_moderator == 0) {
						Toast('无权限')
					} else {
						that.addHfShow_floor = true;
					}
				}, 600); //这里设置定时
			},
			//手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
			gotouchend() {
				clearTimeout(this.timeOutEvent);
				if (this.timeOutEvent != 0) {
					//这里写要执行的内容（尤如onclick事件）
					// that.tostShow = true;
				}
			},
			//如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按 
			gotouchmove() {
				clearTimeout(this.timeOutEvent); //清除定时器
				this.timeOutEvent = 0;
			},
			// -----------------------------------------------------
			// 置顶帖子接口
			forumSetFn(inx) {
				console.log(inx)
				this.forumSetIdx = inx;
				console.log(this.forumSetIdx)
				if (this.forumSetIdx == 0) { //扎贴
					this.$axios.post(this.$api.stick_forum, {
						forum_id: this.info.id, //帖子id
					}).then(res => {
						Toast(res.data.msg);
						this.forum_detail()
						this.tostShow = false
					})
				} else if (this.forumSetIdx == 1) { //置顶
					this.$axios.post(this.$api.top_forum, {
						forum_id: this.info.id, //帖子id
					}).then(res => {
						Toast(res.data.msg);
						this.forum_detail()
						this.tostShow = false
					})
				} else if (this.forumSetIdx == 2) { //加精
					this.$axios.post(this.$api.digest_forum, {
						forum_id: this.info.id, //帖子id
					}).then(res => {
						Toast(res.data.msg);
						this.forum_detail()
						this.tostShow = false
					})
				} else if (this.forumSetIdx == 3) { //删除
					this.$axios.post(this.$api.del_forum, {
						forum_id: this.info.id, //帖子id
					}).then(res => {
						if (res.data.code == 1) {
							Toast(res.data.msg);
							this.forum_detail()
							this.tostShow = false;
							this.$router.go(-1);
						} else {
							Toast(res.data.msg);
						}

					})
				} else if (this.forumSetIdx == 4) { // 收藏帖子
					this.$axios.post(this.$api.collect_forum, {
						forum_id: this.info.id,
						type: 1
					}).then(res => {
						Toast(res.data.msg);
						this.forum_detail()
						this.tostShow = false
					})
				} else if (this.forumSetIdx == 5) { //投诉
					this.$toast('投诉');
				}
			},
			addHfFn(idx) {

				if (idx == 0) {
					this.$axios.post(this.$api.del_comment, {
						comment_id: this.clearHfId
					}).then(res => {
						Toast(res.data.msg);
						this.forum_detail()
						this.addHfShow = false
					})
				}
			},
			backForum() {
				this.$router.go(-1);
			},
			navbarFn(data) {
				this.navBarIndex = data
			},
			tzglTost() { //帖子管理按钮
				this.tostShow = !this.tostShow
			},
			hideTost() { //隐藏弹窗
				this.tostShow = !this.tostShow
			},
			hideTost01() {
				this.addHfShow = !this.addHfShow
			},
			jumpHtgc() {
				this.$router.push({
					path: '/bookcity',
					query: {
						getSecondtab: 6,
						getFirstvaluetab: null,
						gettabArridx: 6,
					}
				})
			},

			forum_detail() {
				var apiurl = this.$api.$BASE_URL_img;
				// 
				this.$axios.post(this.$api.forum_detail, {
					//  139
					forum_id: this.$route.query.tzxqInfoId
				}).then(res => {
					console.log(res)
					if (res.data.data.info.anonymous == 1) {
						// res.data.data.info.nickname = this.anonymous_name[Math.floor(Math.round() * this.anonymous_name.length)];
						res.data.data.info.user_avatar = this.anonymous_url[Math.floor(Math.random() * 3)];
					}
					this.info = res.data.data.info;
					if (res.data.data.info.content.replace('https://yunjin.yuanboming.com/')) {
						this.info.content = res.data.data.info.content.replace('/uploads', "/uploads");
					} else if (res.data.data.info.content.replace('https://www.yjwxc.com/')) {
						this.info.content = res.data.data.info.content.replace('/uploads', "/uploads");
					} else {
						this.info.content = res.data.data.info.content.replace('/uploads', apiurl + "/uploads");
					}
					var list = res.data.data.reply;
					var srcReg = /src=([\'\"]?([^\'\"]*)[\'\"]?)/ig;
					for (var i = 0; i < list.length; i++) {
						if (list[i].anonymous == 1) {
							// list[i].nickname = this.anonymous_name[Math.floor(Math.random() * this.anonymous_name.length)];
							list[i].user_avatar = this.anonymous_url[Math.floor(Math.random() * 3)];
						}
						
						if(list[i].c_content){  
							if(list[i].c_content.indexOf('https://www.yjwxc.com/') == -1){
								list[i].c_content = list[i].c_content.replace(srcReg,"src='"+apiurl+'$2'+"'");
							}else{
								list[i].c_content = list[i].c_content;
							}
						}
						// if(list[i].children.length){
						// 	for(var j = 0; j < list[i].children.length; j++){
						// 		if(list[i].children[j].anonymous == 1){
						// 			list[i].children[j].nickname = this.anonymous_name[Math.floor(Math.random()*this.anonymous_name.length)];
						// 		}
						// 	}
						// }
					}
					this.reply = list;
					this.is_moderator = res.data.data.is_moderator;

					// this.nickname = res.data.data.info.nickname;
				})
			},
			//展示更多评论
			showComment(index) {
				// 因为vue的机制，在渲染玩完成后新添加的数据要用$set
				if (!this.reply[index].show_comment) {
					this.$set(this.reply[index], 'show_comment', true);
				} else {
					// 当有了数据就用正常的取反就行了
					this.reply[index].show_comment = !this.reply[index].show_comment;
				}
			},
			hfFn(id, name , nickname) {
				this.placeShow = true;
				this.forum_id = id; //帖子id
				this.forumShow = !this.forumShow;
				this.nickShow = true;
				this.nickname = '回复：' + name || nickname;
			},
			forumUpimgFn() {
				if (!localStorage.getItem('userInfoData')) {
					this.$toast('您还没有登录，不能发帖哟!');
				} else {
					this.$router.push({
						path: '/forum_upimg',
						query: {
							forum_id: this.$route.query.tzxqInfoId,
							comment_id: this.forum_id,
							content: this.sendValue,
							anonymous: Number(this.scRadio)
						}
					})
				}
			},
			sendFn() { //回复
				if (!localStorage.getItem('userInfoData')) {
					this.$toast('您还没有登录，不能发帖哟!');
				} else {
					this.$axios.post(this.$api.reply_forum, {
						forum_id: this.$route.query.tzxqInfoId,
						comment_id: this.forum_id || '',
						content: this.sendValue,
						anonymous: Number(this.scRadio),
					}).then(res => {
						if (res.data.code == 1) {
							// this.sendFn = false;
							this.sendValue = '';
							this.forum_id = '';
							Toast(res.data.msg);
							this.forum_detail();
						} else {
							Toast(res.data.msg);
						}
						this.forumShow = !this.forumShow;
					})
				}
			},
			// 删除该贴
			deleThisTz() {
				if (this.is_moderator == 0) {
					Toast('无权删除')
				} else if (this.is_moderator == 1) {

				}
			},
			// 话题列表
			hot_talk() {
				this.$axios.post(this.$api.hot_talk).then(res => {
					this.hotTalk = res.data.data;
				})
			},
			formatDateTime(dateNum) {
				var date = new Date(dateNum * 1000);
				return date.getFullYear() + "-" + fixZero(date.getMonth() + 1, 2) + "-" + fixZero(date.getDate(), 2) + " " +
					fixZero(date.getHours(), 2) + ":" + fixZero(date.getMinutes(), 2) + ":" + fixZero(date.getSeconds(), 2);

				function fixZero(num, length) {
					var str = "" + num;
					var len = str.length;
					var s = "";
					for (var i = length; i-- > len;) {
						s += "0";
					}
					return s + str;
				}
			},
			// 删除楼层
			// delbind(id) {
			// 	var _t = this;
			// 	_t.$axios.post(_t.$api.del_comment, {
			// 		comment_id: id
			// 	}).then(res => {
			// 		Toast(res.data.msg);
			// 		_t.forum_detail();
			// 	})
			// },
			addHfFn_floor() {
				var _t = this;
				_t.$axios.post(_t.$api.del_comment, {
					comment_id: _t.clearHfId_floor
				}).then(res => {
					if (res.data.code == 1) {
						_t.forum_detail();
						_t.addHfShow_floor = false;
					}
					Toast(res.data.msg);

				})

			},
			hideTost_floor() {
				this.addHfShow_floor = false;
			}
		}
	}
</script>


<style lang="less" scoped>
	/deep/.w-e-toolbar {
		display: none;
	}

	/deep/.editor {
		min-height: 80px;
		overflow: scroll;
		
		font-size: 30px;/*px*/
		/deep/p {
			margin: 0;
			font-size: 30px;/*px*/
		}

		/deep/.text {
			height: 50px;
			overflow: hidden;
			padding-left: 80px;
			padding-top: 18px;
			padding-right:90px;
			box-sizing: border-box;
			font-size: 35px;/*px*/
		}

		/deep/.w-e-text {
			padding-top: 16px;
			/*px*/
			font-size: 30px;/*px*/
		}
	}

	.tieziInfoBox {
		background-color: #fff;
		height: 100vh;
		color: #000;

		// 头部
		.headerBox {
			height: 160px;
			background-color: #fff;
			display: flex;
			// background: url() no-repeat 0% 88%;
			// background-size: 100%;
			position: relative;

			.backImg {
				position: absolute;
				bottom: 10px;
				left: 0;
				width: 100%;
			}

			.headerQuery {
				margin-top: 80px;
				padding: 0 20px;
				position: relative;
				display: flex;
				width: 100%;
				height: 80px;
				line-height: 80px;
				color: #000;
				border-bottom: 1px solid #f0f0f0;

				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}

				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}

				.header_qk {
					img {
						position: absolute;
						top: 50%;
						right: 16px;
						transform: translateY(-50%);
						width: 60px;
						height: 60px;
					}
				}
			}

		}

		//帖子标题
		.tieziTitle {
			padding: 20px;
			// margin-bottom: 0;
			padding-bottom: 20px;
			background-color: #fff;
			border-bottom: 1px solid #f0f0f0;

			/*no*/
			h4 {
				font-size: 34px;
				/*px*/
				line-height: 60px;
				/*px*/
				font-weight: bold;
				color: #000;
			}

			.tieziTit_top {
				font-size: 26px;
				/*px*/
				overflow: hidden;
				padding-bottom: 20px;
				padding-top: 20px;

				img {
					width: 60px;
					height: 60px;
					vertical-align: middle;
					// margin-right:20px;
					border-radius: 50%;
				}

				.tieziListItem_top_left {
					float: left;
					margin-top: 10px;
					margin-left: 6px;
					width: 60px;
					height: 60px;
					border-radius: 50%;
					box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.4);

					img {
						vertical-align: middle;
						width: 60px;
						height: 60px;
						border-radius: 50%;
					}
				}

				.tieziListItem_top_right {
					float: left;
					margin-left: 20px;
					line-height: 40px;

					span {
						padding-right: 20px;
						font-size: 30px;
						/*px*/
					}

					.grayColor {
						color: #7f7f7f;
						font-size: 24px;
						/*px*/

						span {
							font-size: 24px;
						}
					}
				}
			}

			.tieziTit_bottom {
				width: calc(100vw - 32px);
				// line-height: 40px;
				overflow: hidden;
				font-size: 34px;
				/*px*/
				line-height: 60px;
				/*px*/

				/deep/ p {
					font-size: 34px;
					/*px*/
					line-height: 60px;
					/*px*/
				}

				/deep/h1,
				/deep/h2,
				/deep/h3,
				/deep/h4,
				/deep/h5,
				/deep/h6,
					{
					font-size: 34px;
					/*px*/
					line-height: 60px;
					/*px*/
					font-weight: normal;
				}

				.tieziTit_bottom_footer {
					display: flex;
					padding-bottom: 20px;
					border-bottom: 1px solid #f0f0f0;

					/*no*/
					.timeData {
						flex: 1;
						line-height: 60px;
						color: #7f7f7f;

						.time {
							padding-left: 10px;
						}
					}

					.btn {
						flex: 1;
						text-align: right;
						margin-top: 10px;

						span {
							border: 1px solid #fa7298;
							/*no*/
							color: #fa7298;
							border-radius: 10px;
							padding: 0 15px;
							display: inline-block;
						}

						.tieziGl {
							// width: 130px;
							position: relative;

							i {
								font-style: normal;
								margin-right: 20px;
							}

							img {
								width: 20px;
								position: absolute;
								top: 50%;
								right: 10px;
								transform: translateY(-50%);
							}
						}

						.tieziDel {
							margin-left: 20px;
						}
					}
				}
			}
		}

		//导航
		.navBar {
			padding: 20px;
			display: flex;
			background-color: #fff;

			.navBarBox {
				text-align: left;
				font-size: 26px;
				/*px*/
				position: relative;

				span {
					line-height: 60px;
					/*px*/
					display: inline-block;
					color: #3d3d3d;
					font-size: 34px;
					/*px*/
				}

				p {
					width: 100%;
					height: 4px;
					position: absolute;
					bottom: 0px;
					left: 0;
					background-color: transparent;
					border-radius: 4px;
				}

			}

			.navBarBox:first-of-type {
				margin-right: 40px;
			}

			div.active {
				p {
					background-color: #f4ce72;
				}

				span {
					color: #000;
					font-weight: bold;
				}
			}

			.jumpHtgc {
				text-align: right;
				flex: 1;
				line-height: 60px;

				img {
					vertical-align: middle;
					width: 30px;
				}

				span {
					color: #fa7298;
				}
			}
		}

		//帖子列表
		.tieziListBox {
			padding: 0 20px 170px 20px;
			background-color: #fff;

			// height: calc(100vh - 500px);
			// overflow: scroll;
			.father_reply {
				// border-bottom: 2px dashed #f0f0f0;/*no*/
				.dashed{
					width: 100%;
					height: 1px;
					background-image: linear-gradient(to right, #ccc 0%, #f0f0f0 50%, transparent 50%);
					background-size: 60px 1px;
					background-repeat: repeat-x;
				}
				.tieziListItem_top_rightFather {
					// margin-left: 86px;
					line-height: 40px;
					color: #8f8f8f;
					// opacity: 0.8;

					span {
						padding-right: 20px;
						font-size: 26px;

						/*px*/
						i {
							font-style: normal;
						}
					}

					span:first-child {
						display: inline-block;
					}

					span:last-child {
						display: block;
					}

					.grayColor {
						color: #8f8f8f;
						font-size: 24px;
						/*px*/
						display: inline-block;

						span {
							font-size: 24px;
							display: inline-block;
						}
					}
				}

				.txtBox {
					font-size: 34px;
					/*px*/
					padding: 10px 0;
					/*px*/
					line-height: 60px;
					/*px*/
					color: #8f8f8f;

					.txtBoxOverHidden {
						height: 120px;
						overflow: hidden;
						// overflow: hidden;
						// white-space: nowrap;
						// text-overflow: ellipsis;
						-webkit-line-clamp: 2;
						line-clamp: 2;
					}
				}
			}

			.bor_top {
				padding-top: 20px;
			}

			.er_reply {
				color: #767676;
				padding: 10px 30px;
				border-radius: 4px;

				.list_item {
					line-height: 50px;
					padding: 0 30px;
					box-sizing: border-box;
					border-bottom: 1px solid #fff;
					background-color: #f0f0f0;

					.top_text {
						width: 100%;
						display: flex;
						flex-direction: row;
						justify-content: space-between;

						.name {
							color: #3d3d3d;
						}

						.floor {
							color: #ff4081;
						}
					}

					.content {
						overflow: hidden;
						width: 100%;
						max-height: 95px;
					}

					.time {
						width: 100%;

						.er_reply_time {
							font-size: 24px;
							/*px*/
							color: #848484;
						}
					}
				}

				.list_item:last-child {
					border-bottom: 0;
				}

				.threelist {
					display: none;
				}

				.threelist:nth-child(1) {
					display: block;
				}

				.threelist:nth-child(2) {
					display: block;
				}

				.threelist:nth-child(3) {
					display: block;
				}
			}

			.more_comment {
				padding: 14px 10px;
				color: #666666;
				text-align: center;
				display: flex;
				flex-direction: row;
				justify-content: center;
				align-items: center;
				color: #ff4081;

				img {
					width: 25px;
					margin-left: 10px;
				}
			}

			.tieziListItem {
				padding: 20px 0;
				border-bottom: 1px solid #f0f0f0;
				/*no*/
				padding-bottom: 0px;

				.tieziListItem_top {
					overflow: hidden;

					.tieziListItem_top_left {
						float: left;
						margin-top: 10px;
						margin-left: 6px;
						width: 60px;
						height: 60px;
						border-radius: 50%;
						box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.4);

						img {
							vertical-align: middle;
							width: 60px;
							height: 60px;
							border-radius: 50%;
						}
					}

					.tieziListItem_top_right {
						float: left;
						margin-left: 20px;
						line-height: 40px;

						span {
							padding-right: 20px;
							font-size: 26px;
							/*px*/
						}

						.grayColor {
							color: #7f7f7f;
							font-size: 24px;
							/*px*/
						}
					}
				}

				.tieziListItem_footer {
					padding-top: 20px;
					padding-bottom: 20px;
					font-size: 34px;
					/*px*/
					// line-height: 60px;/*px*/
					position: relative;
					word-break: break-all;

					/deep/p {
						line-height: 60px;
						/*px*/
					}

					.ltxiaoxi {
						position: absolute;
						bottom: 20px;
						right: 0;
						width: 40px;
					}

					.del_btn {
						position: absolute;
						bottom: 20px;
						right: 70px;
						width: 38px;
					}
				}
			}

		}

		//回复
		.huifuInput {
			width: calc(100vw - 40px);
			width: 100vw;
			position: absolute;
			bottom: 0;
			left: 0;
			height: 160px;
			background-color: #fff;
			// border-top: 1px solid #f0f0f0;/*no*/
			.add_imgs {
				position: absolute;
				top: 50%;
				left: 40px;
				transform: translateY(-50%);
				width: 50px;
				z-index: 99999;
			}
			.radio_nm {
				flex: 1;
				text-align: right;
				position: absolute;
				top: 50%;
				right: 19%;
				transform: translateY(-50%);
				z-index: 99999;
			
				/deep/ .van-checkbox__label--left {
					margin: 0 5px 0 0;
				}
			
				/deep/.van-radio-group {
					/deep/.van-radio__icon .van-icon {
						width: 30px;
						height: 30px;
						line-height: 30px;
						font-size: 24px;
					}
			
					/deep/.van-radio__label {
						font-size: 22px;
						/*px*/
					}
				}
			}
			
			.input_hf {
				position: absolute;
				top: 50%;
				transform: translateY(-50%);
				width: 80%;
				margin-left: 16px;
				min-height: 80px;
				// max-height:135px;
				line-height: 80px;
				border-radius: 80px;
				position: relative;
				border: 1px solid #ffdd2b;
				/*no*/
				overflow-y: scroll;
				i{
					position: absolute;
					left: 100px;
					top: 50%;
					transform: translateY(-50%);
					font-style: normal;
					width: 80%;
				}
				input {
					width: 100%;
					background-color: transparent;
					padding-left: 80px;
					border-radius: 80px;
					padding-right: 140px;
					box-sizing: border-box;
				}

				
				/deep/.editor{
					// min-height: 50px;
					height: 40px;
					/deep/p{
						font-size: 30px;/*px*/
					}
				}
				
			}
			
			.input_hf02 {
				position: absolute;
				top: 50%;
				transform: translateY(-50%);
				width: 80%;
				margin-left: 16px;
				min-height: 80px;
				max-height:135px;
				line-height: 80px;
				border-radius: 80px;
				position: relative;
				border: 1px solid #ffdd2b;
				/*no*/
				overflow-y: scroll;
				i{
					position: absolute;
					left: 100px;
					top: 50%;
					transform: translateY(-50%);
					font-style: normal;
					width: 80%;
				}
				input {
					width: 100%;
					background-color: transparent;
					padding-left: 80px;
					border-radius: 80px;
					padding-right: 140px;
					box-sizing: border-box;
				}
			
				
				/deep/.editor{
					min-height: 50px;
					/deep/p{
						font-size: 30px;/*px*/
					}
				}
				
			}

			span {
				text-align: center;
				position: absolute;
				top: 50%;
				right: 10px;
				transform: translateY(-50%);
				background-color: #ffdd2b;
				color: #fff;
				padding: 15px 30px;
				border-radius: 20px;
			}
		}

		//热门话题
		.hotHuati {
			padding: 0 20px;
			padding-bottom: 40px;

			p {
				line-height: 60px;
				color: #1f1f1f;
				font-size: 30px;
				/*px*/
			}

			p.active {
				color: #fb83a5;
			}
		}

		//弹窗
		.luntantost {
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100vw;
			// height: 454px;
			background: url(../../assets/img/luntanImg.png) no-repeat;
			background-size: 100%;
			z-index: 99999;

			img {
				position: absolute;
				bottom: 40px;
				left: 0;
				width: 100%;
			}

			.luntantostbgc {
				margin-top: 124px;
				z-index: 10000 !important;
				background: url(../../assets/img/cat.png) no-repeat #fff;
				background-size: 100%;
				background-position: 0px 50%;

				div {
					line-height: 120px;
					text-align: center;
					color: #737373;
					font-size: 30px;
					/*px*/
					z-index: 1000 !important;
				}

				div.active {
					color: #ff4081;
				}

			}

		}

		.mask {
			position: fixed;
			top: 0;
			left: 0;
			width: 100vw;
			height: 100vh;
			background-color: rgba(0, 0, 0, .3);
		}
	}
</style>
